import React from "react";
import "../../styles/OurCompaniesSlider.css";
import companyLogo1 from "../../assets/images/CompanyLogos/almg.jpeg";
import companyLogo2 from "../../assets/images/CompanyLogos/Ceylon-Hospital.jpg";
import companyLogo3 from "../../assets/images/CompanyLogos/chcare.jpeg";
import companyLogo4 from "../../assets/images/CompanyLogos/ch-w-logo.jpg";
import companyLogo5 from "../../assets/images/CompanyLogos/chconnect.jpeg";
import companyLogo6 from "../../assets/images/CompanyLogos/yakkala.jpeg";
import companyLogo7 from "../../assets/images/CompanyLogos/siddha.jpeg";

const OurCompaniesSlider = () => {
  const companies = [
    { id: 1, logo: companyLogo1 },
    { id: 2, logo: companyLogo2 },
    { id: 3, logo: companyLogo3 },
    { id: 4, logo: companyLogo4 },
    { id: 5, logo: companyLogo5 },
    { id: 6, logo: companyLogo6 },
    { id: 7, logo: companyLogo7 },
  ];



  const duplicateArray = (arr, times) => {
    const result = [];
    for (let i = 0; i < times; i++) {
      result.push(...arr);
    }
    return result;
  };
  
  const duplicatedCompanies = duplicateArray(companies, 20);
  

  return (
    <div className="slider-container_com">
      <div className="slider_com">
        {duplicatedCompanies.map((company, index) => (
          <div className="slide hover:opacity-85 " key={index}>
            <img src={company.logo} alt={`Company ${company.id}`} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default OurCompaniesSlider;
